import { Collection, Model } from 'web-mojo';

class RouteTemplate extends Model {
    constructor(data = {}) {
        super(data, {
            endpoint: '/api/routes/template'
        });
    }

    nameOrId() {
        return this.get('name') || this.get('id');
    }

    isDraft() {
        return this.get('status') === 'draft';
    }

    isPublished() {
        return this.get('status') === 'published';
    }

    isArchived() {
        return this.get('status') === 'archived';
    }

    defaultOperatorName() {
        const op = this.get('default_operator');
        return op ? (op.display_name || op.user?.username || '') : 'None';
    }

    totalDistanceKm() {
        const meters = this.get('total_distance_meters');
        return meters ? (meters / 1000).toFixed(1) : null;
    }

    totalDurationMins() {
        const secs = this.get('total_duration_seconds');
        return secs ? Math.round(secs / 60) : null;
    }
}

class RouteTemplateList extends Collection {
    constructor(options = {}) {
        super({
            ModelClass: RouteTemplate,
            endpoint: '/api/routes/template',
            ...options
        });
    }
}

const RouteTemplateForms = {
    create: {
        title: 'New Route Template',
        fields: [
            { name: 'name', type: 'text', label: 'Name', columns: 12 },
            { name: 'route_type', type: 'text', label: 'Route Type', columns: 6 },
            { name: 'recurrence_pattern', type: 'text', label: 'Recurrence', columns: 6 },
            { name: 'default_start_address', type: 'text', label: 'Start Address (Depot)', columns: 12 },
            { name: 'timezone', type: 'text', label: 'Timezone', columns: 6 },
        ]
    },
    edit: {
        title: 'Edit Route Template',
        fields: [
            { name: 'name', type: 'text', label: 'Name', columns: 12 },
            { name: 'route_type', type: 'text', label: 'Route Type', columns: 6 },
            { name: 'recurrence_pattern', type: 'text', label: 'Recurrence', columns: 6 },
            { name: 'default_start_address', type: 'text', label: 'Start Address (Depot)', columns: 12 },
            { name: 'timezone', type: 'text', label: 'Timezone', columns: 6 },
        ]
    }
};

RouteTemplate.EDIT_FORM = RouteTemplateForms.edit;
RouteTemplate.ADD_FORM = RouteTemplateForms.create;

export { RouteTemplate, RouteTemplateList, RouteTemplateForms };
